import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

const Portal = ({ children }) => {
  // Create a div element only once when the component mounts
  const [element] = useState(() => document.createElement('div'));

  useEffect(() => {
    // Ensure the body exists
    if (!document.body) return;

    // Add the portal to body
    document.body.appendChild(element);
    
    // Set some basic styling for the portal element
    element.style.position = 'fixed';
    element.style.top = '0';
    element.style.left = '0';
    element.style.width = '100%';
    element.style.height = '100%';
    element.style.zIndex = '1000';
    
    // Clean up function
    return () => {
      // Safety check to ensure the element is actually in the DOM before removing
      if (element && element.parentNode === document.body) {
        document.body.removeChild(element);
      }
    };
  }, [element]);

  return ReactDOM.createPortal(children, element);
};

export default Portal; 